import React, { FC } from 'react';
import styled from 'styled-components';

import { Context } from '../Context';

const InputLabel = styled.label`
  display: block;
  color: ${({ theme }) => theme.colors.highlightText};
  font-size: ${({ theme }) => theme.fontSizes.baseText};
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 22px;
`;

export const Label: FC = ({ children }) => (
  <Context.Consumer>
    {({ name }) => <InputLabel htmlFor={name}>{children}</InputLabel>}
  </Context.Consumer>
);
try {
    // @ts-ignore
    Label.displayName = "Label";
    // @ts-ignore
    Label.__docgenInfo = { "description": "", "displayName": "Label", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/FormItem/Label/index.tsx#Label"] = { docgenInfo: Label.__docgenInfo, name: "Label", path: "src/components/FormItem/Label/index.tsx#Label" };
}
catch (__react_docgen_typescript_loader_error) { }